import Vue from "vue";
import Router from "vue-router";
import PreviewfileFormat from "@/components/PreviewfileFormat";
import PreviewMim from "@/components/mim/index.vue";
import ProcessRoutes from "./routes/process";
import CaseRoutes from "./routes/case";
import Deliver from "./routes/deliver";

// import { resolve } from 'dns';

Vue.use(Router);

export default new Router(
  {
    // mode: "history",
    // base: __dirname,
    routes: [
      {
        path: "/",
        component: (resolve) => require(["../components/index.vue"], resolve),
        meta: {
          title: "MIM",
          type: "login", // 是否需要判断是否登录,这里是需要判断
          allowBack: false,
        },
      },
      {
        path: "/MimCaseTwo",
        name: "MimCaseTwo",
        component: (resolve) =>
          require(["../components/Case/MimCaseTwo.vue"], resolve),
        meta: {
          title: "MimCaseTwo",
          vis: false,
        },
      },
      {
        path: "/MimCaseOne",
        name: "MimCaseOne",
        component: (resolve) =>
          require(["../components/Case/MimCaseOne.vue"], resolve),
        meta: {
          title: "MimCaseOne",
          vis: false,
          type: "login",
          alias: "场景漫游",
        },
      },
      {
        path: "/MimCaseFour",
        name: "MimCaseFour",
        component: (resolve) =>
          require(["../components/Case/MimCaseFour.vue"], resolve),
        meta: {
          title: "MimCaseFour",
          vis: false,
          type: "login",
          alias: "加载GIS环境",
        },
      },
      {
        path: "/MimCaseSix",
        name: "MimCaseSix",
        component: (resolve) =>
          require(["../components/Case/MimCaseSix.vue"], resolve),
        meta: {
          title: "MimCaseSix",
          vis: false,
          type: "login",
          alias: "设备管理",
        },
      },
      {
        path: "/RH_gis",
        name: "RH_gis",
        component: (resolve) =>
          require(["../components/Case/RH_gis.vue"], resolve),
        meta: {
          title: "RH_gis",
          vis: false,
          type: "login",
          alias: "RH-加载GIS地图",
        },
      },
      {
        path: "/RH_gis_other",
        name: "RH_gis_other",
        component: (resolve) =>
          require(["../components/Case/RH_gis_other.vue"], resolve),
        meta: {
          title: "RH_gis_other",
          vis: false,
          type: "login",
          alias: "RH-GIS地图",
        },
      },
      {
        path: "/ModelExplosion",
        name: "ModelExplosion",
        component: (resolve) =>
          require(["../components/Case/ModelExplosion.vue"], resolve),
        meta: {
          title: "ModelExplosion",
          vis: false,
        },
      },
      {
        path: "/PlaneScanAnimation",
        name: "PlaneScanAnimation",
        component: (resolve) =>
          require(["../components/Case/PlaneScanAnimation.vue"], resolve),
        meta: {
          title: "PlaneScanAnimation",
          vis: false,
        },
      },
      ...CaseRoutes,
      {
        path: "/YQS_geo_resource",
        name: "YQS_geo_resource",
        component: (resolve) =>
          require(["../components/Case/YQS_geo_resource.vue"], resolve),
        meta: {
          title: "YQS_geo_resource",
          vis: false,
        },
      },
      {
        path: "/Safety_management",
        name: "Safety_management",
        component: (resolve) =>
          require(["../components/Case/Safety_management.vue"], resolve),
        meta: {
          title: "Safety_management",
          vis: false,
        },
      },
      {
        path: "/Topology_map",
        name: "Topology_map",
        component: (resolve) =>
          require(["../components/Case/Topology_map.vue"], resolve),
        meta: {
          title: "Topology_map",
          vis: false,
        },
      },
      {
        path: "/geological",
        name: "geological",
        component: (resolve) =>
          require(["../components/deliver/geological.vue"], resolve),
        meta: {
          title: "geological",
          vis: false,
        },
      },
      {
        path: "/Schedule",
        name: "Schedule",
        component: (resolve) =>
          require(["../components/Case/Schedule/index.vue"], resolve),
        meta: {
          title: "Schedule",
          vis: false,
        },
      },
      {
        path: "/viewFileModel",
        name: "viewFileModel",
        component: (resolve) =>
          require([
            "../components/deliver/deliverData/viewFileModel.vue",
          ], resolve),
        meta: {
          title: "viewFileModel",
          vis: false,
        },
      },
      // {
      //     path: '/Shovel_loader',
      //     name: 'Shovel_loader',
      //     component: resolve => require(['../components/Case/Shovel_loader.vue'], resolve),
      //     meta: { title: 'Shovel_loader', vis: false }
      // },

      {
        path: "/RoamingCase",
        name: "RoamingCase",
        component: (resolve) =>
          require(["../components/Case/RoamingCase.vue"], resolve),
        meta: {
          title: "RoamingCase",
          vis: false,
          type: "login",
          alias: "RH-厂区漫游",
        },
      },
      {
        path: "/unity",
        name: "unity",
        component: (resolve) =>
          require(["../components/Case/unity.vue"], resolve),
        meta: {
          title: "unity",
          vis: false,
          type: "login",
          alias: "unity演示",
        },
      },
      {
        path: "/view",
        name: "view",
        component: (resolve) =>
          require(["../components/Case/view.vue"], resolve),
        meta: {
          title: "view",
          vis: false,
        },
      },
      {
        path: "/previewFileFormat",
        name: "previewfileFormat",
        component: PreviewfileFormat,
        meta: {
          title: "PreviewfileFormat",
          alias: "图纸模型预览",
        },
      },
      {
        path: "/previewMim",
        name: "previewMim",
        component: PreviewMim,
        meta: {
          title: "PreviewMim",
          alias: "mim图纸模型预览",
        },
      },
      {
        path: "/drawingModelShare",
        name: "drawingModelShare",
        component: (resolve) =>
          require([
            "../components/drawingManagements/drawingModelShare.vue",
          ], resolve),
        meta: {
          title: "drawingModelShare",
          alias: "分享图纸模型预览",
        },
      },
      {
        path: "/share/document",
        name: "shareDocument",
        component: (resolve) =>
          require(["../components/shareFile.vue"], resolve),
        meta: {
          title: "ShareFile",
          alias: "文档分享",
        },
      },
      {
        path: "/share/gis",
        name: "shareGis",
        component: (resolve) =>
          require(["../components/Case/RH_gis_other.vue"], resolve),
        meta: {
          title: "ShareGis",
          alias: "GIS分享",
        },
      },
      {
        path: "/YQS_trans_system",
        name: "YQS_trans_system",
        component: (resolve) =>
          require(["../components/Case/YQS_trans_system.vue"], resolve),
        meta: {
          title: "YQS_trans_system",
          vis: false,
          type: "login",
          alias: "YQS-开拓运输系统",
        },
      },
      {
        path: "/",
        component: (resolve) =>
          require(["../components/common/Home.vue"], resolve),
        meta: {
          title: "Home",
          type: "login",
          alias: "系统首页",
        },
        children: [
          //   {
          //   path: '/survey',
          //   name: 'survey',
          //   component: resolve => require(['../components/Survey.vue'], resolve),
          //   meta: { title: 'Survey', vis: true, type: 'login', alias: '项目概况', icon: 'el-icon-coin' }
          // },
          {
            path: "/survey",
            name: "survey2",
            component: (resolve) =>
              require(["../components/survey2.vue"], resolve),
            meta: {
              title: "Survey",
              vis: true,
              type: "login",
              alias: "项目概况",
              icon: "el-icon-coin",
            },
          },
          {
            path: "/fileControl",
            name: "fileControl",
            component: (resolve) =>
              require([
                "../components/documentManagement/fileControl.vue",
              ], resolve),
            meta: {
              title: "FileControl",
              vis: true,
              type: "login",
              alias: "文档管理",
              icon: "el-icon-folder-opened",
            },
          },
          {
            path: "/drawingManagement",
            name: "drawingManagement",
            component: (resolve) =>
              require([
                "../components/drawingManagements/drawingManagement.vue",
              ], resolve),
            meta: {
              title: "DrawingManagement",
              vis: true,
              type: "login",
              alias: "图纸管理",
              icon: "el-icon-document",
            },
          },
          {
            path: "/model",
            name: "model",
            component: (resolve) =>
              require(["../components/modelManagement/MimModel.vue"], resolve),
            meta: {
              title: "MimModel",
              vis: true,
              type: "login",
              alias: "MIM模型",
              icon: "el-icon-box",
            },
          },

          {
            path: "/IntegratedModel",
            name: "IntegratedModel",
            component: (resolve) =>
              require([
                "../components/modelManagement/IntegratedModel.vue",
              ], resolve),
            meta: {
              title: "IntegratedModel",
              vis: false,
              type: "login",
              alias: "MIM模型集成",
              icon: "el-icon-box",
            },
          },
          ...Deliver,
          {
            path: "/control",
            name: "control",
            component: (resolve) =>
              require(["../components/ControlPage.vue"], resolve),
            meta: {
              title: "ControlPage",
              vis: false,
              type: "login",
              alias: "MIM应用",
              icon: "el-icon-money",
            },
          },
          {
            path: "/oxygen",
            name: "oxygen",
            component: (resolve) =>
              require(["../components/oxygen/viewDrawing.vue"], resolve),
            meta: {
              title: "oxygenPage",
              vis: false,
              type: "login",
              alias: "氧气站",
              icon: "el-icon-sunset",
            },
          },
          {
            path: "/MyApplication",
            name: "MyApplication",
            component: (resolve) =>
              require(["../components/MyApplication.vue"], resolve),
            meta: {
              title: "MyApplication",
              vis: true,
              type: "login",
              alias: "MIM我的应用",
              icon: "el-icon-money",
            },
          },
          {
            path: "/meeting",
            name: "meeting",
            component: (resolve) =>
              require(["../components/EnfiMeeting.vue"], resolve),
            meta: {
              title: "EnfiMeeting",
              vis: false,
              type: "login",
              alias: "视频会议",
              icon: "el-icon-video-camera-solid",
            },
          },
          {
            path: "/nextcloud",
            name: "nextcloud",
            component: (resolve) =>
              require(["../components/EnfiNextcloud.vue"], resolve),
            meta: {
              title: "EnfiNextcloud",
              vis: false,
              type: "login",
              alias: "协同网盘",
              icon: "el-icon-s-platform",
            },
          },
          ...ProcessRoutes,
          {
            path: "/projectSettings",
            name: "projectSettings",
            component: (resolve) =>
              require([
                "../components/projectManagement/projectSettings.vue",
              ], resolve),
            meta: {
              title: "ProjectSettings",
              vis: true,
              type: "login",
              alias: "项目设置",
              icon: "el-icon-setting",
            },
          },
          {
            path: "/MimCaseThree",
            name: "MimCaseThree",
            component: (resolve) =>
              require(["../components/Case/MimCaseThree.vue"], resolve),
            meta: {
              title: "MimCaseThree",
              vis: false,
              type: "login",
              alias: "三维管控模型案例3",
            },
          },
          {
            path: "/MimCaseFive",
            name: "MimCaseFive",
            component: (resolve) =>
              require(["../components/Case/MimCaseFive.vue"], resolve),
            meta: {
              title: "MimCaseFive",
              vis: false,
              type: "login",
              alias: "三维管控模型案例5",
            },
          },
          {
            path: "/viewModel",
            name: "viewModel",
            component: (resolve) =>
              require(["../components/modelManagement/viewModel.vue"], resolve),
            meta: {
              title: "ViewModel",
              vis: false,
              type: "login",
              alias: "查看模型",
            },
          },
          {
            path: "/viewDrawing",
            name: "viewDrawing",
            component: (resolve) =>
              require([
                "../components/drawingManagements/viewDrawing.vue",
              ], resolve),
            meta: {
              title: "ViewDrawing",
              vis: false,
              type: "login",
              alias: "查看图纸",
            },
          },
          {
            path: "/comparPreview",
            name: "comparPreview",
            component: (resolve) =>
              require([
                "../components/drawingManagements/comparPreview.vue",
              ], resolve),
            meta: {
              title: "comparPreview",
              vis: false,
              type: "login",
              alias: "查看对比图纸",
            },
          },
          // {
          //   path: "/information",
          //   name: 'information',
          //   component: resolve => require (['../components/information/information.vue'], resolve),
          //   meta: {title: "Information",vis:true,type: 'login',alias:'消息',icon:'el-icon-chat-line-round'}
          // },
          {
            path: "/viewPdf",
            name: "viewPdf",
            component: (resolve) =>
              require(["../components/viewPdf.vue"], resolve),
            meta: {
              title: "viewPdf",
              vis: false,
              type: "login",
              alias: "查看pdf图纸",
            },
          },
          {
            path: "/deliveryBasis",
            name: "deliveryBasis",
            component: (resolve) =>
              require(["../components/deliver/deliveryBasis.vue"], resolve),
            meta: {
              title: "deliveryBasis",
              vis: false,
              type: "login",
              alias: "交付基础",
            },
          },
          // ...Deliver,
          {
            path: "/dataReport",
            name: "dataReport",
            component: (resolve) =>
              require(["../components/deliver/dataReport.vue"], resolve),
            meta: {
              title: "dataReport",
              vis: false,
              type: "login",
              alias: "数据报表",
            },
          },
          {
            path: "/docManagement",
            name: "docManagement",
            component: (resolve) =>
              require([
                "../components/deliver/docManagement/index.vue",
              ], resolve),
            meta: {
              title: "docManagement",
              vis: false,
              type: "login",
              alias: "文件管理",
            },
          },
          {
            path: "/searchPage",
            name: "searchPage",
            component: (resolve) =>
              require(["../components/deliver/searchPage/index.vue"], resolve),
            meta: {
              title: "searchPage",
              vis: false,
              type: "login",
              alias: "搜索",
            },
          },
          {
            path: "/relationManagement",
            name: "relationManagement",
            component: (resolve) =>
              require([
                "../components/deliver/relationManagement/index.vue",
              ], resolve),
            meta: {
              title: "relationManagement",
              vis: false,
              type: "login",
              alias: "关联关系管理",
            },
          },
          {
            path: "/projectObject",
            name: "projectObject",
            component: (resolve) =>
              require([
                "../components/deliver/projectObject/index.vue",
              ], resolve),
            meta: {
              title: "projectObject",
              vis: false,
              type: "login",
              alias: "工程对象",
            },
          },
        ],
      },
      {
        path: "/information",
        name: "information",
        component: (resolve) =>
          require(["../components/information/information.vue"], resolve),
        meta: {
          title: "Information",
          vis: true,
          type: "login",
          alias: "消息",
          icon: "el-icon-chat-line-round",
        },
      },
      {
        path: "/sigin",
        name: "sigin",
        component: (resolve) =>
          require(["../components/login/sigin.vue"], resolve),
        meta: {
          title: "signIn",
          alias: "登录",
        },
      },
      {
        path: "/register_rotocol",
        name: "register_rotocol",
        component: (resolve) =>
          require(["../components/register_rotocol.vue"], resolve),
        meta: { title: "signIn", alias: "MIM协同交付平台" },
      },
      {
        path: "/newIntegration",
        name: "newIntegration",
        component: (resolve) =>
          require([
            "../components/modelManagement/newIntegration.vue",
          ], resolve),
        meta: { title: "newIntegration", alias: "MIM协同交付平台" },
      },
      {
        path: "/integrationModelPreview",
        name: "integrationModelPreview",
        component: (resolve) =>
          require([
            "../components/modelManagement/integrationModelPreview.vue",
          ], resolve),
        meta: {
          title: "PreviewfileFormat",
          alias: "集成模型预览",
        },
      },
      {
        path: "/modelLinkage",
        name: "modelLinkage",
        component: (resolve) =>
          require(["../components/modelManagement/modelLinkage.vue"], resolve),
        meta: { title: "modelLinkage", alias: "二三维模型联动" },
      },
      {
        path: "/guidePage",
        name: "guidePage",
        component: (resolve) =>
          require(["../components/login/guidePage.vue"], resolve),
        meta: {
          title: "guidePage",
          alias: "引导页",
        },
      },
      {
        path: "/otherLogin",
        name: "otherLogin",
        component: (resolve) =>
          require(["../components/login/otherLogin.vue"], resolve),
        meta: {
          title: "otherLogin",
          alias: "其他登录",
        },
      },
      {
        path: "/problemFeedback",
        name: "problemFeedback",
        component: (resolve) =>
          require(["../components/problemFeedback/index.vue"], resolve),
        meta: {
          title: "problemFeedback",
          alias: "问题反馈",
        },
      },
      {
        path: "/instructionManual",
        name: "instructionManual",
        component: (resolve) =>
          require([
            "../components/helpDocument/instructionManual.vue",
          ], resolve),
        meta: {
          title: "instructionManual",
          alias: "使用说明书",
        },
      },
      {
        path: "/registrationAndExit",
        name: "registrationAndExit",
        component: (resolve) =>
          require([
            "../components/helpDocument/registrationAndExit.vue",
          ], resolve),
        meta: {
          title: "registrationAndExit",
          alias: "使用说明书",
        },
      },
      {
        path: "/projectManagement",
        name: "projectManagement",
        component: (resolve) =>
          require([
            "../components/helpDocument/projectManagement.vue",
          ], resolve),
        meta: {
          title: "registrationAndExit",
          alias: "使用说明书",
        },
      },
      {
        path: "/fileManagement",
        name: "fileManagement",
        component: (resolve) =>
          require(["../components/helpDocument/fileManagement.vue"], resolve),
        meta: {
          title: "fileManagement",
          alias: "使用说明书",
        },
      },
      {
        path: "/drawingMan",
        name: "drawingMan",
        component: (resolve) =>
          require([
            "../components/helpDocument/drawingManagement.vue",
          ], resolve),
        meta: {
          title: "drawingManagement",
          alias: "使用说明书",
        },
      },
      {
        path: "/MIMmodelManagement",
        name: "MIMmodelManagement",
        component: (resolve) =>
          require([
            "../components/helpDocument/MIMmodelManagement.vue",
          ], resolve),
        meta: {
          title: "MIMmodelManagement",
          alias: "使用说明书",
        },
      },
    ],
  },
  {
    path: "/information",
    name: "information",
    component: (resolve) =>
      require(["../components/information/information.vue"], resolve),
    meta: {
      title: "Information",
      vis: true,
      type: "login",
      alias: "消息",
      icon: "el-icon-chat-line-round",
    },
  },
  {
    path: "/sigin",
    name: "sigin",
    component: (resolve) => require(["../components/login/sigin.vue"], resolve),
    meta: {
      title: "signIn",
      alias: "登录",
    },
  },
  {
    path: "/register_rotocol",
    name: "register_rotocol",
    component: (resolve) =>
      require(["../components/register_rotocol.vue"], resolve),
    meta: { title: "signIn", alias: "MIM协同交付平台" },
  },
  {
    path: "/newIntegration",
    name: "newIntegration",
    component: (resolve) =>
      require(["../components/modelManagement/newIntegration.vue"], resolve),
    meta: { title: "newIntegration", alias: "MIM协同交付平台" },
  },
  {
    path: "/integrationModelPreview",
    name: "integrationModelPreview",
    component: (resolve) =>
      require([
        "../components/modelManagement/integrationModelPreview.vue",
      ], resolve),
    meta: {
      title: "PreviewfileFormat",
      alias: "集成模型预览",
    },
  }
);



// WEBPACK FOOTER //
// ./src/router/index.js